import { useState, useEffect } from 'react';
import { scorm } from '@/api';

const useGetScorm = (queryParams) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchScorm = async () => {
    setIsError(false);
    setLoading(true);
    try {
      const result = await scorm.list(queryParams);
      result.code === 200
        ? setData(result.data[0])
        : setIsError(true);
    } catch (e) {
      setIsError(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchScorm();
  }, []);

  return { loading, isError, data };
};

export default useGetScorm;
